import type { TRuleWithTheme } from '@/styles/theme';

export const root: TRuleWithTheme = () => ({
    marginTop: 20,
    maxWidth: 396,
});
